import React, { useEffect, useState } from 'react';
import Table from 'components/preform/Table';
import DeleteModal from 'components/general/DeleteModal';
// import Dropdown from 'components/inputs/DropDown';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_FORM, FETCH_FORMS } from 'actions/formActions';
import Pagination from 'components/general/Pagination';
import { Spinner } from 'react-bootstrap';

const AllForms = () => {
  const { forms, totalPages = '', totalResults = '', loading } = useSelector((state) => state.forms);
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteFormId, setDeleteFormId] = useState(null);
  const [filterSettings, setFilterSettings] = useState({
    page: 1,
    limit: 20,
    sortBy: '-createdAt',
    search: '',
    username: '',
    status: '',
    fromDate: '',
    toDate: '',
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [usernameFilter, setUsernameFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
  };
  // const options = [
  //   { label: 'All', value: '' },
  //   { label: 'Admin', value: 'admin' },
  //   { label: 'CE', value: 'engineer' },
  // ];

  useEffect(() => {
    fetchForms();
  }, [JSON.stringify(filterSettings)]);

  const fetchForms = () => {
    const payload = Object.fromEntries(
      Object.entries(filterSettings).filter(([, value]) => value !== '' && value !== null && value !== undefined)
    );
    dispatch({
      type: FETCH_FORMS,
      payload,
    });
  };

  // const setRole = (option) => {
  //   if (option.value != '') {
  //     setFilterSettings((state) => ({ ...state, role: option.value }));
  //   } else {
  //     delete filterSettings.role;
  //     setFilterSettings(filterSettings);
  //   }
  // };

  const handleDeleteBtn = (formId) => {
    setDeleteFormId(formId);
    setShowDeleteModal(true);
  };

  const onRemove = () => {
    dispatch({ type: DELETE_FORM, payload: deleteFormId });
    setShowDeleteModal(false);
  };

  const changePage = ({ selected: pageIndex }) => {
    setFilterSettings((state) => ({ ...state, page: pageIndex + 1 }));
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setFilterSettings((state) => ({ ...state, search: value }));
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsernameFilter(value);
    setFilterSettings((state) => ({ ...state, username: value }));
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    setFilterSettings((state) => ({ ...state, status: value }));
  };

  const handleFromDateChange = (e) => {
    const value = e.target.value;
    setFromDate(value);
    setFilterSettings((state) => ({ ...state, fromDate: value }));
  };

  const handleToDateChange = (e) => {
    const value = e.target.value;
    setToDate(value);
    setFilterSettings((state) => ({ ...state, toDate: value }));
  };

  const clearAllFilters = () => {
    setSearchTerm('');
    setUsernameFilter('');
    setStatusFilter('');
    setFromDate('');
    setToDate('');
    setFilterSettings((state) => ({
      ...state,
      search: '',
      username: '',
      status: '',
      fromDate: '',
      toDate: '',
      page: 1,
    }));
  };

  return (
    <>
      <div className="page-body">
        <div className="container-xl  new_application">
          <div className="row gap-2  align-items-center">
            <div className="col">
              <h2 className="page-title">All Forms</h2>
            </div>
            <div className="col-auto d-flex gap-4 ms-auto d-print-none">
              {/* <Dropdown label="Select" options={options} onChange={setRole} /> */}
              <div className="btn-list">
                <Link to="/allforms/form" className="btn btn-primary d-sm-inline-block">
                  New Application
                </Link>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-12">
                <div className="filters d-flex gap-3 flex-wrap align-items-center">
                  <input
                    type="text"
                    placeholder="Search by name, station, charger"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="form-control"
                    style={{ maxWidth: '200px' }}
                  />
                  <input
                    type="text"
                    placeholder="Filter by Username"
                    value={usernameFilter}
                    onChange={handleUsernameChange}
                    className="form-control"
                    style={{ maxWidth: '200px' }}
                  />
                  <select
                    value={statusFilter}
                    onChange={handleStatusChange}
                    className="form-control"
                    style={{ maxWidth: '200px' }}
                  >
                    <option value="">Filter by Status</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="rework">Re-Work</option>
                    <option value="commission">Ready to Commission</option>
                    <option value="draft">Draft</option>
                  </select>
                  <input
                    type="date"
                    placeholder="From Date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    className="form-control"
                    style={{ maxWidth: '150px' }}
                  />
                  <input
                    type="date"
                    placeholder="To Date"
                    value={toDate}
                    onChange={handleToDateChange}
                    className="form-control"
                    style={{ maxWidth: '150px' }}
                  />
                  <button className="btn btn-secondary" onClick={clearAllFilters}>
                    Clear All Filters
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12 mt-2 mb-2">
              {loading ? (
                <div className="loader-container">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <>
                  <Table data={forms} handleDeleteBtn={handleDeleteBtn} />
                  <Pagination
                    total={totalResults}
                    handlePageClick={changePage}
                    currentPage={filterSettings.page}
                    limit={filterSettings.limit}
                    totalPages={totalPages}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && <DeleteModal show={showDeleteModal} title="Form" onClose={handleCloseDeleteModel} onRemove={onRemove} />}
    </>
  );
};
export default AllForms;
